import { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { DropzoneArea } from 'material-ui-dropzone';
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import Quote from "../Components/Quote";
import Service from "../Components/Service";
import ServiceInclude from "../Components/ServiceInclude";
import GetSupport from "../Components/GetSupport";
import { url, header } from "../Constent/Constant";

function Home() {
  const [HomeData, setHomeData] = useState('')
  const [HeadingUpdate, setHeadingUpdate] = useState('')
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [ImageUpdate, setImageUpdate] = useState(null)
  const [ImageModal, setImageModal] = useState(false);
  const [UpdateId, setUpdateId] = useState('')
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if (LoggedIn !== 'true') {
    history.push('/')
  }


  useEffect(() => {
    UpdateData()
  }, [])

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "Home"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setHomeData(data.doc)
      })
  }

  const UpdateText = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/page/updatedata`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append('image', DataObject.image)
    Imagedata.append('id', DataObject.id)

    fetch(`${url}/page/updateimage`, {
      method: 'POST',
      body: Imagedata
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.message === 'Success') {
          UpdateData()
        }
      })
  }

  const handleCancel = () => {
    setTextModalVisible(false);
    setImageModal(false);
  };

  const ShowTextModal = (id) => {
    setTextModalVisible(true);
    setUpdateId(id)
  };

  const showImageModal = (id) => {
    setImageModal(true);
    setUpdateId(id)
  };

  const TextHandle = () => {
    if (HeadingUpdate === '') {
      message.error('Fill the Field')
    } else {
      UpdateText({
        text: HeadingUpdate,
        id: UpdateId
      })
      setTextModalVisible(false);
      setHeadingUpdate('')
    }
  };

  const OnImageHandle = () => {
    if (ImageUpdate === null) {
      message.error('Insert Image')
    } else {
      UpdateImage({
        image: ImageUpdate,
        id: UpdateId
      })
      setImageModal(false);
    }
  };

  const OnEnterPress = (event) => {
    const a = HeadingUpdate
    console.log(a)
    if (event.key === 'Enter') {
      console.log('Enter Clicked')
      a.concat('\n')
      setHeadingUpdate(a)
    } else {
      console.log(event.key)
    }
  }


  return (
    <Layout>
      {HomeData && <Header
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={{
          imgId: HomeData.section1image1._id,
          headingId: HomeData.section1heading1._id
        }}
        Image={HomeData.section1image1.image} />
      }

      <div className='Home'>
        {HomeData && <Quote
          btnText='Call us (844)-346-2264'
          UpdateText={UpdateText}
          UpdateImage={UpdateImage}
          SubHeading={HomeData ? HomeData.section2subheading1.content : 'No Text'}
          SectionData={{
            SubHeadingId: HomeData.section2subheading1._id,
            image: HomeData.section2image1.image,
            imageId: HomeData.section2image1._id,
            heading: HomeData.section2heading1.content,
            headingId: HomeData.section2heading1._id,
            para1: HomeData.section2paragraph1.content,
            para1Id: HomeData.section2paragraph1._id,
          }} />}
      </div>

      {HomeData && <Service
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={HomeData}
      />}

      {HomeData && <ServiceInclude
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        Data={HomeData}
      />}

      {HomeData && <GetSupport
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        Data={HomeData}
      />}

      {HomeData && <div className='Home-Contact'>
        <div className='Blank'></div>
        <i onClick={() => showImageModal(HomeData.section6image1._id)} className="far fa-edit Edit-btn"></i>
        <img src={`${url}/api/getFile${HomeData.section6image1.image}`} alt='Img' draggable={false} />
        <div className='Content'>
          <h3> {HomeData.section6heading1.content}
            <i onClick={() => ShowTextModal(HomeData.section6heading1._id)} className="far fa-edit Edit-btn"></i>
          </h3>
          <div className='Para-div'>
            <i onClick={() => ShowTextModal(HomeData.section6paragraph1._id)} className="far fa-edit Edit-btn"></i>
            <p>{HomeData.section6paragraph1.content}</p>
          </div>
          <button className='Primary-btn Button'>CONTACT US</button>
        </div>
      </div>}


      {/* Update Text Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
        <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
      </Modal>

      {/* Update Image Modal */}
      <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
        <DropzoneArea
          filesLimit={1}
          acceptedFiles={['image/*']}
          dropzoneText={"Update Product Images"}
          onChange={(files) => {
            console.log('Files:', files[0])
            setImageUpdate(files[0])
          }}
        />
      </Modal>

    </Layout>
  );
}

export default Home;
